import { useEffect, useRef, useState } from 'react';
import { CHAT_CHANGES, subscribeChatEvents, eventRefresh } from '../services/chatEvents';

export default function useChatEvents(kind, token, refresh) {
  const callback = useRef(refresh);
  callback.current = refresh;
  const [status, setStatus] = useState('connecting');
  useEffect(() => {
    if (!token) return undefined;
    const loader = eventRefresh(() => callback.current());
    const unsubscribe = subscribeChatEvents(kind, token, event => {
      if (event.type === 'connection') setStatus(event.status);
      else if (CHAT_CHANGES.has(event.type)) loader.request();
    });
    return () => { unsubscribe(); loader.dispose(); };
  }, [kind, token]);
  return status;
}
